import { HttpErrorResponse } from '@angular/common/http';
import { TrackJS } from 'trackjs';
import { TRACKJSCONFIG } from '../../constants/analytics-constants';

interface TrackJSConfig {
  name?: string;
  token: string;
  application: string;
}
export class ExceptionTrackingService {
  hostname = '';
  envConfig: TrackJSConfig[];
  constructor() {
    this.hostname = document.location.hostname;
    this.envConfig = TRACKJSCONFIG;
    this._setConfig(this.hostname, this.envConfig);
  }

  _setConfig(host: string, config: TrackJSConfig[]): boolean {
    const [env]: TrackJSConfig[] = config
      .filter(({ name }) => name === host)
      .map((x: TrackJSConfig) => {
        delete x.name;
        return x;
      });
    if (!TrackJS.isInstalled()) {
      return TrackJS.install(env);
    }
    return false;
  }

  track(error: HttpErrorResponse) {
    TrackJS.track(error);
  }
}
